/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to upload a new claim photo.
 * @export
 * @interface CreateClaimPhotoRequest
 */
export interface CreateClaimPhotoRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPhotoRequest
     */
    filename: string;
    /**
     * Supported image or video MIME type (image/jpeg, image/png, image/gif, image/webp, image/bmp, image/avif, video/mp4, or video/webm)
     * @type {string}
     * @memberof CreateClaimPhotoRequest
     */
    mimeType: string;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimPhotoRequest
     */
    sizeBytes: number;
    /**
     * Base64 encoded file content
     * @type {string}
     * @memberof CreateClaimPhotoRequest
     */
    fileContent: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPhotoRequest
     */
    caption?: string | null;
}

/**
 * Check if a given object implements the CreateClaimPhotoRequest interface.
 */
export function instanceOfCreateClaimPhotoRequest(value: object): value is CreateClaimPhotoRequest {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('sizeBytes' in value) || value['sizeBytes'] === undefined) return false;
    if (!('fileContent' in value) || value['fileContent'] === undefined) return false;
    return true;
}

export function CreateClaimPhotoRequestFromJSON(json: any): CreateClaimPhotoRequest {
    return CreateClaimPhotoRequestFromJSONTyped(json, false);
}

export function CreateClaimPhotoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimPhotoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'sizeBytes': json['sizeBytes'],
        'fileContent': json['fileContent'],
        'caption': json['caption'] == null ? undefined : json['caption'],
    };
}

export function CreateClaimPhotoRequestToJSON(json: any): CreateClaimPhotoRequest {
    return CreateClaimPhotoRequestToJSONTyped(json, false);
}

export function CreateClaimPhotoRequestToJSONTyped(value?: CreateClaimPhotoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'sizeBytes': value['sizeBytes'],
        'fileContent': value['fileContent'],
        'caption': value['caption'],
    };
}

